module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Políticas de Privacidade","home":"Home"},"en":{"title":"Privacy Policies","home":"Home"},"es":{"title":"Políticas de Privacidad","home":"Inicio"}}')
  delete Component.options._Ctor
}
